<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-tabs
        class="back-content-tabs"
        :default-active-key="selectedTab"
        :active-key="selectedTab"
        :animated="false"
        @change="tabChange"
      >
        <a-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab.title"
        >
          <component :is="tab.component" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </page-header-wrapper>
</template>

<script>
import Summary from './Summary.vue'
import CalenderYear from './CalenderYear.vue'
import CouponRunWater from './CouponRunWater.vue'

const settingTabs = [
  {
    title: '资源发放与流水汇总',
    key: 'summary',
    component: 'Summary'
  },
  {
    title: '资源发放自然年度统计',
    key: 'calenderYear',
    component: 'CalenderYear'
  },
  {
    title: '发券流水自然年度统计',
    key: 'couponRunWater',
    component: 'CouponRunWater'
  }
]

export default {
  components: {
    Summary,
    CalenderYear,
    CouponRunWater
  },
  data () {
    return {
      tabs: settingTabs,
      selectedTab: ''
    }
  },
  watch: {
    '$route.query.tab': {
      handler: function (val) {
        this.setSelectedTab()
      }
    }
  },
  created () {
    this.setSelectedTab()
  },
  methods: {
    setSelectedTab () {
      if (this.$route.query && this.$route.query.tab) {
        this.selectedTab = this.$route.query.tab
      } else {
        this.selectedTab = this.tabs[0].key
      }
    },
    tabChange (activeKey) {
      this.$router.push({
        name: 'dispenseflow',
        query: {
          tab: activeKey
        }
      })
    }
  }
}
</script>
